import React from 'react';
import PropTypes from 'prop-types';
import ItemElement from '../ItemElement';

export default class Service extends React.Component {
  render() {
    const {
      as,
      title,
      price,
      description,
      charLimit,
      image,
      cardInlinePhoto,
      imageCircular,
      imageSize,
      itemButtonFloat,
      itemCenterContent,
      link,
      linkAs,
      verticalItemAlign,
    } = this.props;

    return (
      <ItemElement
        as={as}
        header={title}
        subheader={price}
        content={description}
        charLimit={charLimit}
        image={image}
        cardInlinePhoto={cardInlinePhoto}
        imageCircular={imageCircular}
        imageSize={imageSize}
        itemButtonFloat={itemButtonFloat}
        itemCenterContent={itemCenterContent}
        link={link}
        linkAs={linkAs}
        verticalItemAlign={verticalItemAlign}
      />
    );
  }
}

Service.propTypes = {
  title: PropTypes.string.isRequired,
  as: PropTypes.oneOf(['verticalItem', 'horizontalItem', 'card']),
  cardInlinePhoto: PropTypes.oneOf(['left', false]),
  charLimit: PropTypes.number,
  description: PropTypes.string,
  image: PropTypes.string,
  imageCircular: PropTypes.bool,
  imageSize: PropTypes.string,
  itemButtonFloat: PropTypes.oneOf(['left', 'right']),
  itemCenterContent: PropTypes.bool,
  link: PropTypes.string,
  linkAs: PropTypes.oneOf(['header', 'none']),
  price: PropTypes.string,
  verticalItemAlign: PropTypes.oneOf(['left', 'right', 'center']),
};

Service.defaultProps = {
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 200,
  description: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  price: '',
  verticalItemAlign: 'center',
};
